function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import { rehydrateDateAfterJsonization as V } from "../util/date-utils.js";

var ti = /*#__PURE__*/function () {
  function ti(t, i, s, l, h) {
    _classCallCheck(this, ti);

    this.endpoint = t, this.En = i, this.publicKey = s, this.Vl = l, this.fl = h, this.endpoint = t || null, this.En = i || null, this.publicKey = s || null, this.Vl = l || null, this.fl = h || null;
  }

  _createClass(ti, [{
    key: "bt",
    value: function bt() {
      return {
        e: this.endpoint,
        c: this.En,
        p: this.publicKey,
        u: this.Vl,
        v: this.fl
      };
    }
  }], [{
    key: "Rn",
    value: function Rn(t) {
      return new ti(t.e, V(t.c), t.p, t.u, t.v);
    }
  }]);

  return ti;
}();

export { ti as default };